import React, { useContext } from 'react';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import InputConfig from '../../../../../Components/InputConfig';
import CheckBoxInput from '../../../../../Components/CheckBoxInput';

//mui imports====
import useCommonStyles from '../../../../../commonStyles';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
//===============

const ModeCustomLabelConfig = ({ keyData, title }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	return (
		<>
			<Grid container spacing={1} className={commonStyleClasses.basicOutlinedBox}>
				<Grid item xs={12} style={{ marginBottom: '.5rem' }}>
					<Typography fontWeight={200} variant="h4">
						{title}
					</Typography>
				</Grid>
				<Grid item xs={6}>
					<CheckBoxInput
						keyData={keyData + '.enabled'}
						label="enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
						containerStyles={{
							width: 'fit-content',
							marginTop: '3rem',
							marginLeft: '0'
						}}
					/>
				</Grid>
				<Grid item xs={6}>
					<InputConfig
						label="Height"
						keyData={keyData + '.height'}
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
						editable={!!rawConfig[keyData + '.enabled']}
					/>
				</Grid>
				<Grid item xs={6}>
					<InputConfig
						label="Width"
						keyData={keyData + '.width'}
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
						editable={!!rawConfig[keyData + '.enabled']}
					/>
				</Grid>
				<Grid item xs={6}>
					<InputConfig
						label="Position"
						keyData={keyData + '.position'}
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
						editable={!!rawConfig[keyData + '.enabled']}
					/>
				</Grid>
			</Grid>
		</>
	);
};
export default ModeCustomLabelConfig;
